import { render, staticRenderFns } from "./News_desc.vue?vue&type=template&id=36fce7dc&"
import script from "./News_desc.vue?vue&type=script&lang=js&"
export * from "./News_desc.vue?vue&type=script&lang=js&"
import style0 from "./News_desc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports